export const EXPIRY_NUDGE_WINDOW_DAYS = 30;
